import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface Payload {
  patientName?: string;
  planCode: string;
  userName: string;
  cardNumber?: string;
}

interface PlanData {
  id: number;
    partner_plan_id: number;
    partner_plan_code: string;
    partner_plan_name: string;
    partner_plan_is_particular: boolean;
    partner_plan_has_validity: boolean;
    status_code: string;
    status_name: string;
    card_number: string;
    default: boolean;
    plan_group: {
      id: number;
      category: string;
      code: string;
      name: string;
      has_vitrine: boolean;
      logo_url: string;
      validity_renew: boolean;
      allows_reservation: boolean;
    };
}

interface Error {
  response: {
    status: number;
  };
}

interface AxiosResponse {
  data: PlanData
}

export const linkPlan = ({
  patientName,
  planCode,
  userName,
  cardNumber,
}: Payload): Promise<PlanData> => {
  const endpoint = apiEndpoints.PATIENTS_PLANS(userName, planCode)

  const params = {
    ...(patientName && { cardholder_name: patientName }),
    ...(cardNumber && { card_number: cardNumber }),
  }

  return new Promise<PlanData>((resolve, reject) => {
    axios
      .post(endpoint, params)
      .then((response: AxiosResponse) => resolve(response.data))
      .catch((error: Error) => {
        reject(error.response.status)
      })
  })
}
